import React, { createContext, useContext, useEffect, useState } from "react";
import API from "../api/api";
import ApiUri from "../api/api-uri";
import { User } from "../models/user/user";
import * as SnackBar from "node-snackbar";
import "node-snackbar/dist/snackbar.css";
import { GlobalLoaderContext } from "./global-loader";
import Colors from "../enums/colors";
import { setCookie } from "../App";

export interface IAuthContext {
  user?: User;
  setUser?: any;
  jwt?: string;
  setJwt?: any;
  userImageUrl?: string;
  setUserImageUrl?: any;
  profileNameLogin: string;
  setProfileNameLogin: any;
  profileImageURLLogin: string;
  setProfileImageURLLogin: any;
  profileUrlName: any;
  setProfileUrlName: any;
  showSignup: any;
  setShowSignup: any;
  userEmail?: string;
  setUserEmail?: any;
}

export const AuthContext = createContext({} as IAuthContext);

export const getJwtFromCookies = () => {
  const value = `; ${document.cookie}`;
  const parts: any = value.split(`; ${process.env.REACT_APP_MCZTOKEN_COOKIE}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

const AuthContextProvider = ({ children }: any) => {
  const jwtFromCookies = getJwtFromCookies();
  const [jwt, setJwt] = useState(jwtFromCookies ?? "");
  const [user, setUser] = useState<any>(undefined);
  const [userImageUrl, setUserImageUrl] = useState<string>("");
  const [profileNameLogin, setProfileNameLogin] = useState("");
  const [profileImageURLLogin, setProfileImageURLLogin] = useState("");
  const [loader, setLoader] = useState(false);
  const [profileUrlName, setProfileUrlName] = useState("");
  const [showSignup, setShowSignup] = useState(true);
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    if (!user && jwt) {
      setLoader(true);
      // SnackBar.show({
      //   showAction: false,
      //   text: "Please wait, loading application ...",
      //   pos: "bottom-center",
      //   duration: 15000,
      // });

      const config = {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      };
      API.get(ApiUri.MY_ACCOUNT, config).then(
        (response) => {
          const userFromEndpoint = response.data.data;
          API.get(ApiUri.USER + ApiUri.IMAGE, config).then((response) => {
            const imageUrl = response.data.data.image;
            setUserImageUrl(imageUrl);
            setUser(userFromEndpoint);
            setUserEmail(userFromEndpoint.email);
            setLoader(false);
          });
        },
        (error) => {
          setCookie(process.env.REACT_APP_MCZTOKEN_COOKIE, "", 14);
        }
      );
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        jwt,
        setJwt,
        userImageUrl,
        setUserImageUrl,
        profileNameLogin,
        setProfileNameLogin,
        profileImageURLLogin,
        setProfileImageURLLogin,
        profileUrlName,
        setProfileUrlName,
        showSignup,
        setShowSignup,
        userEmail,
        setUserEmail,
      }}
    >
      {loader ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: Colors.primary,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999999,
          }}
        >
          <style>{`
            @keyframes mmaz-pulse {
              0%, 80%, 100% { transform: scale(0.6); opacity: 0.3; }
              40% { transform: scale(1); opacity: 1; }
            }
            .mmaz-dot {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: #889263;
              margin: 0 5px;
              animation: mmaz-pulse 1.4s ease-in-out infinite;
            }
            .mmaz-dot:nth-child(1) { animation-delay: 0s; }
            .mmaz-dot:nth-child(2) { animation-delay: 0.2s; }
            .mmaz-dot:nth-child(3) { animation-delay: 0.4s; }
          `}</style>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span className="mmaz-dot" />
            <span className="mmaz-dot" />
            <span className="mmaz-dot" />
          </div>
        </div>
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
